import React from 'react'
import "../components/HomeMarqueeText.css";
import { gsap } from "gsap";
import $ from 'jquery';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef } from 'react';

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);


const GCMarqueeText = (prop) => {



    const marqueeContainer = useRef(null);

    let containerWidth = $('.container').width();

    useLayoutEffect(()=>
    {

   // Marquee Text
   
    //   const tlMarqueeTextBg = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: marqueeContainer.current,
    //       start: 'top 100% ',
    //       end: 'bottom 100%',
    //       scrub: 1,
    //       markers: true
    //     },
        
    //   });
    //   tlMarqueeTextBg.fromTo(marqueeContainer.current,
    //   {
    //     width: 0,
    //   },
    //   { 
    //     width: "100%",
        
    //   })


    // const tlMarqueeText = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: 'section.home-marquee-text ',
    //       start: 'top 100%',
    //       end: 'bottom 10%',
    //       scrub: 1,
    //       markers: false
    //     },
        
    //   });




      
      
    //   tlMarqueeText.fromTo(
    //     'section.home-marquee-text .marquee-wrapper',
    //     { x: window.innerWidth },
    //       { x: ()=> {
    //         // let wrapperWidth = $('section.home-marquee-text .marquee-wrapper').width() - containerWidth;
            
    //         let wrapperWidth = marqueeContainer.current?.querySelector('.marquee-wrapper').getBoundingClientRect().width

    //         let spacing = (window.innerWidth - containerWidth)
    //         return ( -wrapperWidth + spacing)  
    //       } 
    //     },
      
    //   )
  
        
    });




  return (
    
    <section className="gc-marquee-text" id="marqueeText" >
        <div className="marquee-wrapper">
            <div className="marquee ">
                <span className="mr-3 font-semibold">{prop.text}</span>
            </div>
            <div className="marquee">
                <span className=" mr-3 font-semibold">{prop.text}</span>
            </div>
       </div>
    </section>
  )
}

export default GCMarqueeText
